import api, { MainDomain } from 'api';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import './header.scss';
import Notifications from './notifications';
import SearchResults from './search-results';
import UserMenu from './user-menu';

function Header() {
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [searching, setSearching] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [searchResults, setSearchResults] = useState<any>([]);
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchExpanded, setSearchExpanded] = useState(false);
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [notifications, setNotifications] = useState<any>([]);
    const params: any = useParams();

    const search = () => {
        if (searchValue.length > 0) {
            setSearching(true);
            api.search(params.clientId, searchValue).then(data => {
                setSearchResults(data);
                setSearching(false);
                setSearchOpen(true);
            })
        }
    }

    const getNotifications = useCallback(() => {
        // api.notification.getAll().then(data => {
        //     setNotifications(data);
        // })
    }, [])

    const markNotificationAsSeen = (id: number) => {
        // api.notification.markAsSeen(id);
        // var copiedData = [...notifications];
        // copiedData[notifications.findIndex((x: any) => x.Id === id)].IsSeen = true;
        // setNotifications(copiedData);
    }

    const deleteNotification = (id: number) => {
        const nots = notifications.filter((x: any) => x.Id !== id);
        if (!nots.length) {
            setTimeout(() => {
                setNotificationsOpen(false);
            }, 200);
        }
        setNotifications(nots);
        api.notification.delete(id);
    }

    useEffect(() => {
        getNotifications();
        setInterval(() => {
            getNotifications();
        }, 3000);
    }, [getNotifications])

    return (
        <>
            <header tabIndex={0} onBlur={() => setTimeout(() => { setSearchOpen(false); setSearchValue('')}, 100)}>
                <h1>{`WORKFLOW ${MainDomain}`}</h1>
                {params.clientId && (<div id="search-box" className={searchExpanded ? 'open': ''} tabIndex={0} onFocus={() => setSearchExpanded(true)} onBlur={() => setSearchExpanded(false)}>
                    <i className="far fa-search"></i>
                    <input type="text" placeholder="Search" value={searchValue} onChange={e => setSearchValue(e.currentTarget.value)} onKeyDown={search} />
                    {searching && <i className="far fa-spinner"></i>}
                </div>)}
                <i className="far fa-bell" onClick={() => {
                    if (!notificationsOpen && userMenuOpen) {
                        setUserMenuOpen(false);
                        setTimeout(() => {
                            setNotificationsOpen(true);
                        }, 200)
                    } else {
                        setNotificationsOpen(!notificationsOpen);
                    }
                }}></i>
                {notifications.filter((x: any) => !x.IsSeen).length > 0 && <span className="notification-count" onClick={() => {
                    if (!notificationsOpen && userMenuOpen) {
                        setUserMenuOpen(false);
                        setTimeout(() => {
                            setNotificationsOpen(true);
                        }, 200)
                    } else {
                        setNotificationsOpen(!notificationsOpen);
                    }
                }}>{notifications.filter((x: any) => !x.IsSeen).length}</span>}
                <i className="far fa-user" onClick={() => {
                    if (!userMenuOpen && notificationsOpen) {
                        setNotificationsOpen(false);
                        setTimeout(() => {
                            setUserMenuOpen(true);
                        }, 200)
                    } else {
                        setUserMenuOpen(!userMenuOpen);
                    }
                }}></i>

            </header>
            <Notifications
                notifications={notifications}
                open={notificationsOpen}
                setOpen={setNotificationsOpen}
                markAsSeen={markNotificationAsSeen}
                deleteNotification={deleteNotification}
            />
            <UserMenu open={userMenuOpen} setOpen={setUserMenuOpen} />
            <SearchResults searchResults={searchResults} open={searchOpen} />
        </>
    )
}

export default Header;